import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { validateAndDecodeAuthToken } from '../utils/helper';
import { AuthTokenResponse } from './service.type';
import { WebSocketProvider } from './context/websocketContext';
import { useAuth } from './context/authContext';

export const AuthenticatedWrapper: FC = () => {
  const validAuthToken: AuthTokenResponse | null = validateAndDecodeAuthToken();
  const { accessToken } = useAuth();

  if (!validAuthToken) {
    return <Navigate to="/login" replace />;
  }

  return (
    <WebSocketProvider
      url={
        `${
          process.env.REACT_APP_WEBSOCKET_URL +
            '?Authorization=' +
            accessToken || ''
        }` || ''
      }
    >
      <Outlet />
    </WebSocketProvider>
  );
};
